<!-- CarouselCard -->
<template>
    <v-card :width="($vuetify.breakpoint.xsOnly) ? '100%' : '490px'" class="pb-2"
        style="border-left: 6px solid #00A0DF ;">
        <v-card-text class="justify-center align-center">
            <v-row>
                <v-col cols="12" md="12" align="center">
                    <v-alert v-if="items.tipo == 'documentacion'" @click="goToUrl" style="cursor: pointer;"
                        class="rounded-0 font-weight-regular text-body-2" dense dark color="orange darken-2"
                        icon="mdi-information" elevation="0">
                        Ver cómo escanear documentación con tu celular
                    </v-alert>
                    <v-card-text class="pa-0">
                        <v-img :src="getImage(items.tipo)" :class="(items.tipo == 'requisitos') ? 'ma-1' : ''"
                            :width="(items.tipo == 'requisitos') ? '55px' : '75px'" />
                        <div class="font-weight-bold primary--text text-body-1">{{ items.title }}</div>
                        <div v-if="items.hasOwnProperty('subtitle')"
                            class="font-weight-bold primary--text text-subtitle-2">
                            {{ items.subtitle }}
                        </div>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text v-if="items.list.length >= 4">
            <v-row class="d-flex flex-row">
                <v-col cols="6" v-for="(item, index) in firstColumn" :key="'first-column-' + index"
                    class="d-flex flex-row justify-start align-start text-left black--text text-body-2">
                    <v-icon color="primary">mdi-circle-medium</v-icon>
                    {{ item }}
                </v-col>
                <v-col cols="6" v-for="(item, index) in secondColumn" :key="'second-column-' + index"
                    class="d-flex flex-row justify-start align-start text-left black--text text-body-2">
                    <v-icon color="primary">mdi-circle-medium</v-icon>
                    {{ item }}
                </v-col>
            </v-row>
        </v-card-text>
        <!-- Display items in a single column if the list length is less than 4 -->
        <v-card-text v-else>
            <v-col cols="12" md="12" v-for="(item, i) in items.list" :key="'single-column-' + i"
                class="d-flex justify-start align-start text-left black--text text-body-2">
                <v-icon color="primary">mdi-circle-medium</v-icon>
                {{ item }}
            </v-col>
        </v-card-text>
    </v-card>
</template>

<script>
import imgRequisitos from '@/assets/subsidios/img-checklist-notebook.png'
import imgPersonales from '@/assets/afiliacion/img-datos-personales.png'
import imgConyuge from '@/assets/afiliacion/img-datos-conyuge.png'
import imgHijo from '@/assets/afiliacion/img-datos-hijos.png'
import imgContacto from '@/assets/afiliacion/img-datos-contacto.png'
import imgProfesionales from '@/assets/afiliacion/img-datos-profesionales.png'
import imgDocumentacion from '@/assets/afiliacion/img-documantacion-digitalizada.png'

export default {
    props: {
        items: {
            required: true
        },
        type: {
            required: false,
            type: String
        }
    },
    components: {
    },

    data() {
        return {
            title: '',
            subtitle: '',
        }
    },
    computed: {
        firstColumn() {
            // Return the first half of the list if it has 4 or more items
            return this.items.list.length >= 4 ? this.items.list.slice(0, Math.ceil(this.items.list.length / 2)) : [];
        },
        secondColumn() {
            // Return the second half of the list if it has 4 or more items
            return this.items.list.length >= 4 ? this.items.list.slice(Math.ceil(this.items.list.length / 2)) : [];
        },
    },
    mounted() {

    },
    methods: {
        getImage(value) {
            switch (value) {
                case 'personales':
                    return imgPersonales;
                case 'conyuge':
                    return imgConyuge;
                case 'hijos':
                    return imgHijo;
                case 'contacto':
                    return imgContacto;
                case 'profesionales':
                    return imgProfesionales;
                case 'documentacion':
                    return imgDocumentacion;
                case 'requisitos':
                    return imgRequisitos;
                default:
                    break;
            }
        },
        goToUrl() {
            const url = "https://www.cajapsipba.org.ar/Instructivo-office-lens.asp"
            window.open(url, '_blank');
        }

    }
}
</script>

<style>
.limit {
    word-wrap: break-word;
}

.espacio-lista {
    margin: 0 0 0 0;
    padding: 0 0 0 0;
}

.contenido {
    word-break: keep-all;
    text-wrap: wrap;
    margin: 1px 0 0 0;
}
</style>